import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { RawHTML } from "../common";
import Dotdotdot from "react-dotdotdot";
import styles from "./styles.less";

class Rate extends Component {
  onClick = () => {
    const {
      onClick,
      rateId,
      priceCode,
      planCode,
      allocationCode,
      roomType
    } = this.props;
    onClick({ rateId, priceCode, planCode, allocationCode, roomId: roomType });
  };

  onReadeMoreClick = e => {
    e.preventDefault();
    e.stopPropagation(); // so we won't select the rate (parent element)
    const { onReadeMoreClick, rateId } = this.props;
    onReadeMoreClick({ rateId });
  };

  renderRate = () => {
    const {
      active,
      planName,
      titleName,
      price,
      isRtl,
      titles,
      isPackage,
      availability,
      lowAvailabilityCount,
      showAvailability,
      showClubPrices,
      ratePriceAfterDiscount,
      isIE,
      image
    } = this.props;
    return (
      <React.Fragment>
        <div
          className={cx(styles.rate, {
            [styles.clickable]: !active,
            [styles.active]: active,
            [styles.rtl]: isRtl
          })}
          onClick={!active ? this.onClick : null}
          onKeyDown={this.onClick}
          role="button"
          tabIndex="0"
        >
          <div className={styles.readMoreSaleWrapper}>
            <div className={styles.rateSale}>
              {isPackage ? titles.Sale + "!!!" : ""}
            </div>
            <div
              className={styles.readMore}
              onClick={this.onReadeMoreClick}
              onKeyDown={this.onReadeMoreClick}
              role="button"
              tabIndex="0"
            >
              {titles.ForMoreDetails}
            </div>
          </div>

          <div className={cx(styles.rateBody, { [styles.active]: active })}>
            {/* {isPackage && (
                <Ribbon
                  text={titles.Sale}
                  isRtl={isRtl}
                  wrapperClassName={styles.ribbonWrapper}
                  textClassName={cx(styles.ribbon, {
                    [styles.rtl]: isRtl
                  })}
                  shape="horizontal"
                  vertical="bottom"
                />
              )} */}
            {image && (
              <img src={image} className={styles.rateImage} alt={titleName} />
            )}
            <div className={styles.rateMainContent}>
              <div className={styles.radioBtnSection} />
              <div className={styles.dataSection}>
                <div className={styles.priceNameWrapper}>
                  <div className={cx(styles.priceName)}>
                    <Dotdotdot
                      className={cx({ [styles.ieIsShit]: isIE })}
                      clamp={2}
                    >
                      <RawHTML html={titleName} />
                    </Dotdotdot>
                  </div>
                </div>
                <div
                  className={cx(styles.planName, { [styles.ieIsShit]: isIE })}
                >
                  <RawHTML html={planName} />
                </div>
                {showAvailability && (
                  <div
                    className={cx(styles.availability, {
                      [styles.lowCount]: availability < lowAvailabilityCount
                    })}
                  >
                    <div className={styles.title}>{titles.Availability}</div>
                    <div className={styles.count}>{availability}</div>
                  </div>
                )}
                <div className={styles.pricesWrapper}>
                  <div className={styles.innerPricesWrapper}>
                    <div
                      className={cx(styles.pricesSection, {
                        [styles.fixedToTheSide]: showClubPrices,
                        [styles.fixedToTheSideRtl]: isRtl
                      })}
                    >
                      <span
                        className={cx(styles.price, {
                          [styles.strikePrice]: showClubPrices,
                          [styles.strikePriceRtl]: isRtl
                        })}
                      >
                        {price}
                      </span>
                      {showClubPrices && (
                        <span className={styles.price}>
                          {ratePriceAfterDiscount}
                        </span>
                      )}
                      <div className={styles.rateOrderButton}>
                        {titles.Checkout}
                      </div>
                    </div>
                    {/* <div className={styles.readMoreSection}>
                        <div
                          className={styles.readMore}
                          onClick={this.onReadeMoreClick}
                          onKeyDown={this.onReadeMoreClick}
                          role="button"
                          tabIndex="0"
                        >
                          {titles.ReadMore}
                        </div>
                      </div> */}
                  </div>
                </div>
              </div>
            </div>
            {/* <div
                className={cx(styles.rateSelectBtn, { [styles.sale]: isPackage })}
              >
                {isPackage ? titles.Sale : titles.SelectRateBtn}
              </div> */}
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    return <React.Fragment>{this.renderRate()}</React.Fragment>;
  }
}

Rate.propTypes = {
  isRtl: PropTypes.bool,
  titles: PropTypes.object,
  rateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  priceCode: PropTypes.string,
  planCode: PropTypes.string,
  planName: PropTypes.string,
  titleName: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  availability: PropTypes.number,
  allocationCode: PropTypes.string,
  lowAvailabilityCount: PropTypes.number,
  showAvailability: PropTypes.bool,
  active: PropTypes.bool,
  isPackage: PropTypes.bool,
  onClick: PropTypes.func,
  onReadeMoreClick: PropTypes.func,
  showClubPrices: PropTypes.bool,
  ratePriceAfterDiscount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  isIE: PropTypes.bool,
  image: PropTypes.string,
  roomType: PropTypes.string
};

Rate.defaultProps = {
  showAvailability: true,
  lowAvailabilityCount: 4,
  titles: {
    ReadMore: "View Daily Rates ..."
  }
};

export default Rate;



// WEBPACK FOOTER //
// ./src/components/Rate/Rate.js